(function() {
  'use strict';
  
  function initializeTicker() {
    const tickers = document.querySelectorAll('.ticker');
    
    tickers.forEach(function(ticker) {
      // Skip if already initialized
      if (ticker.classList.contains('slider_started')) {
        return;
      }
      
      ticker.classList.add('slider_started');
      
      const tickerId = ticker.getAttribute('data-ticker-id');
      const tickerSpeed = parseFloat(ticker.getAttribute('data-ticker-speed')) || 5;
      const speedMs = tickerSpeed * 1000;
      
      // Initialize Swiper for ticker
      new Swiper(`.ticker-js-${tickerId}`, {
        slidesPerView: 'auto',
        speed: speedMs,
        initialSlide: 0,
        loop: true,
        loopedSlides: 50,
        allowTouchMove: false,
        waitForTransition: false,
        watchSlidesProgress: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        on: {
          init: function() {
            console.log('Ticker initialized for ID:', tickerId);
          }
        }
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTicker);
  } else {
    initializeTicker();
  }
  
  // Re-initialize when sections are loaded (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      initializeTicker();
    }, 100);
  });
  
  // Handle visibility change (pause/resume when tab is hidden/visible)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      const tickerElements = document.querySelectorAll('.ticker-js');
      tickerElements.forEach(function(el) {
        if (el.swiper) {
          el.swiper.destroy();
        }
      });
      initializeTicker();
    }
  });
  
  // Fallback initialization
  setTimeout(function() {
    initializeTicker();
  }, 100);
  
})();
